import Switch from "@mui/material/Switch";
import { useState } from "react";

// react-router-dom components
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import { UseSignInWithCredentials } from "0.Mine/1.Hooks/security/signin";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
const bgImage = "https://qlickup.it/media/ai.jpg";

function Illustration() {
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { signinWithCredentials } = UseSignInWithCredentials();
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const { t } = useTranslation();

  const handleSignIn = async () => {
    console.log("Email:", email);
    console.log("Password:", password);

    await signinWithCredentials(email, password, password);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSignIn();
    }
  };

  return (
    <IllustrationLayout
      title={t("signin.signin")}
      description={t("signin.enterEmail")}
      illustration={{
        image: bgImage,
        title: "",
        description: "",
      }}
    >
      <ArgonBox component="form" role="form">
        <ArgonBox mb={2}>
          <ArgonInput
            type="email"
            placeholder="Email"
            size="large"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </ArgonBox>
        <ArgonBox mb={2}>
          <ArgonInput
            type="password"
            placeholder="Password"
            size="large"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </ArgonBox>
        {/*}
        <ArgonBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <ArgonTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;{t("signin.rememberMe")}
          </ArgonTypography>
        </ArgonBox>
        */}
        <ArgonBox mt={4} mb={1}>
          <ArgonButton color="info" size="large" fullWidth onClick={handleSignIn}>
            {t("signin.signin")}
          </ArgonButton>
        </ArgonBox>
        {/*}
        <ArgonBox mt={3} textAlign="center">
          <ArgonTypography variant="button" color="text" fontWeight="regular">
            {t("signin.dontHaveAccount")}
            <ArgonTypography
              component={Link}
              to="/signup"
              variant="button"
              color="info"
              fontWeight="medium"
            >
              {t("signup.signup")}
            </ArgonTypography>
          </ArgonTypography>
        </ArgonBox>
        */}
      </ArgonBox>
    </IllustrationLayout>
  );
}

export default Illustration;
